import script from "./responsive-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./responsive-image.vue?vue&type=script&lang=ts&setup=true"

import "./responsive-image.vue?vue&type=style&index=0&id=15a9c0bf&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a9c0bf"]])

export default __exports__